import {combineReducers}            from "redux"
import Budgets                      from "./Budgets"

const RetrievedRange = combineReducers({
  Budgets
})

export default RetrievedRange
